import { BottomNavigation, BottomNavigationAction, Box, Container } from "@mui/material";
import { PaperCard } from "../../shared/ui/paper-card/paper-card.component";
import DateRangePicker from "../../shared/ui/date/date-range-picker.component";
import { LoadingButton } from "@mui/lab";
import { ToastContainer, toast } from "react-toastify";
import { useEffect, useState } from "react";
import { UseProfitMetrics } from "../../features/metrics/get-profit-metrics/api/useProfitMetrics";
import { ProfitBarchart } from "../../features/metrics/get-profit-metrics/ui/profit-barchart";
import { NetProfitBarchart } from "../../features/metrics/get-profit-metrics/ui/net-profit-barchart";
import { useNavigate } from "react-router-dom";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";

export const GetProfitMetricsPage = () => {
  const {
    metrics,
    handleSetSearchProps,
    searchProps,
    metricsByDay,
    metricsByMonth,
    metricsByWeek,
    error,
    isLoading,
    timeFrame,
    profitInfo,
    payedToTechniciansInfo,
    billedInfo
  } = UseProfitMetrics();
  const { startDate, endDate } = searchProps;

  const navigate = useNavigate();
  const [navItem, setNavItem] = useState(3);

  const handleNavigation = (event: React.SyntheticEvent, item: number) => {
    setNavItem(item);
    switch (item) {
      case 0:
        navigate("/pericias/metrics");
        break;
      case 1:
        navigate("/pericias/metrics/by-costumer");
        break;
      case 2:
        navigate("/pericias/metrics/by-costumers");
        break;
      case 3:
        break;
      default:
        navigate("/");
    }
  };

  const handleDateChange = (start: Date, end: Date) => {
    handleSetSearchProps({ startDate: start, endDate: end });
  };

  const handleGenerateMetrics = () => {
    handleSetSearchProps({ enabled: true });
  };

  useEffect(() => {
    if (!error) return;
    toast.error("Erro ao gerar métricas...");
  }, [error]);

  return (
    <Container>
      <Box mb={5} />
      <BottomNavigation showLabels value={navItem} onChange={handleNavigation} sx={{ marginBottom: "2rem" }}>
        <BottomNavigationAction label="Métricas Nuovauto" icon={<EqualizerIcon />} />
        <BottomNavigationAction label="Métricas cliente" icon={<SignalCellularAltIcon />} />
        <BottomNavigationAction label="Métricas entre clientes" icon={<StackedBarChartIcon />} />
        <BottomNavigationAction label="Métricas faturamento" icon={<TrendingUpIcon />} />
      </BottomNavigation>
      <h1>Métricas - Valor das perícias vs Custo dos técnicos</h1>
      <PaperCard title="Selecione o período">
        <Box mb={3} />
        <DateRangePicker props={{ start: startDate, end: endDate, onChange: handleDateChange }} />
        <Box mb={3} />
        <LoadingButton fullWidth variant="contained" loading={isLoading} onClick={handleGenerateMetrics}>
          Gerar métricas
        </LoadingButton>
      </PaperCard>
      <Box mb={5} />
      <LoadingButton variant="outlined" loading={isLoading} onClick={metricsByDay} style={{ marginRight: "2rem" }}>
        Métricas por dia
      </LoadingButton>
      <LoadingButton variant="outlined" loading={isLoading} onClick={metricsByWeek} style={{ marginRight: "2rem" }}>
        Métricas por semana
      </LoadingButton>
      <LoadingButton variant="outlined" loading={isLoading} onClick={metricsByMonth}>
        Métricas por mes
      </LoadingButton>
      <Box mb={5} />
      {metrics.length > 0 && (
        <>
          <ProfitBarchart
            metrics={metrics}
            payedToTechniciansInfo={payedToTechniciansInfo}
            billedInfo={billedInfo}
            timeFrame={timeFrame}
            startDate={startDate.toLocaleDateString()}
            endDate={endDate.toLocaleDateString()}
          />
          <NetProfitBarchart
            metrics={metrics}
            profitInfo={profitInfo}
            timeFrame={timeFrame}
            startDate={startDate.toLocaleDateString()}
            endDate={endDate.toLocaleDateString()}
          />
        </>
      )}
      <ToastContainer />
    </Container>
  );
};
